import {Button, Modal} from "react-bootstrap";
import {
  generateForm,
  generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {AppContext} from "../../../../appContext/AppContext";
import {XayDungKeHoachContext} from "../DanhSachKeHoach";
import {Formik, Form} from "formik";
import {CODE, TYPE_WH, WF_TRACKER} from "../../../../utils/Constant";
import {toast} from "react-toastify";
import WfButton from "../../../../workflows/components/WfButton";
import {IconButtonSave} from "../../../../component/IconSvg";
import {formatDateDTO} from "../../../../utils/FormatUtils";
import {TypeKeHoach} from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import DynamicComponent from "../../../../component/GenerateDynamicComponent";
import GenerateFormComponent from "../../../../component/generate-form/GenerateFormHTMLNoValid";
import {OPTION_KHAO_SAT, TYPE_KE_HOACH_DAO_TAO, TYPE_KHAO_SAT} from "../constants/constansKeHoach";
import {addPhieuKhaoSat, updatePhieuKhaoSat} from "../services/services";
import TableDangKyDaoTao from "./TableDangKyDaoTao";
import DialogThemMoiDaoTao from "./DialogThemMoiDaoTao";
import AutocompleteObjectV2 from "../../../../component/AutocompleteObjectV2";
import {TYPE_KE_HOACH} from "../../../../quan-ly-ke-hoach/Components/danh-sach-ke-hoach/constants/constansKeHoach";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  warehouseId?: any;
  type: any;
}

const DialogDeNghiChuyenGiao = (props: Props) => {
  const {show, onHide, warehouseId, setInitialValues, initialValues, type} = props;
  const {setIsLoading} = useContext(AppContext);
  const {detailPhieuKeHoach, setDetailPhieuKeHoach} = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(!!detailPhieuKeHoach.id || detailPhieuKeHoach?.isView);
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [listJsonGenerateVT, setListJsonGenerateVT] = useState<any>([]);
  const [initialValuesFormThemVT, setInitialValuesFormThemVT] = useState<any>({});
  const [dataTable, setDataTable] = useState<any>({});
  const [indexRowEdit, setIndexRowEdit] = useState<number | null>(null);
  const [itemSelected, setItemSelected] = useState<any>();
  const [openDialogThemMoi, setOpenDialogThemMoi] = useState<boolean>(false);
  const [typeDialogAddNew, setTypeDialogAddNew] = useState<any>(null);


  const handleFormSubmit = async (values: any) => {
    console.log(values)
    const dataSubmit = {
      slipDto: {
        ...values.khaoSat,
        type: type?.type,
        doCreation: values?.khaoSat?.id ? formatDateDTO(values?.khaoSat?.doCreation) : formatDateDTO(new Date()),
      },
      trackerCode: type?.trackerCode,
      termModelType: type?.formVatTu,
    };

    try {
      setIsLoading(true);
      const id = values?.khaoSat?.id;
      const {data} = id ? await updatePhieuKhaoSat(id, dataSubmit) : await addPhieuKhaoSat(dataSubmit);

      if (CODE.SUCCESS === data?.code) {
        setIsView(true);
        toast.success(((id) ? "Cập nhật" : "Thêm") + " phiếu thành công");
      } else {
        let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
      }
    } catch (error) {
      setIsLoading(false);
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    updateForm();
    updateFormVatTu();
  }, [type]);

  const updateFormVatTu = async () => {
    if (!type?.formVatTu) return;
    const data = await generateForm(type?.formVatTu, setIsLoading);
    setListJsonGenerateVT(data || []);
    setInitialValuesFormThemVT({
      ...generateInitValues(data), ...(initialValues ?? {}),
    });
  };

  const updateForm = async () => {
    if (!type?.formThongTinChung) return;
    const data = await generateForm(type?.formThongTinChung, setIsLoading);
    setListJsonGenerate(data || []);
    setInitialValues({...generateInitValues(data), ...initialValues ?? {}});
  };

  const handler = (data: any) => {
    setInitialValuesFormThemVT({
      ...initialValuesFormThemVT,
      ...data,
      isFirstChange: true,
    });
  };
  const handleOpenDialogThemMoi = (type: any) => {
    setTypeDialogAddNew(type)
    setOpenDialogThemMoi(true);
  }

  const handleAddItem = async (values: any, source?: string) => {
    const key = typeDialogAddNew?.formVatTu;
    const item = values?.[key] || {};
    const list = dataTable?.[key] || [];

    const newList =
      indexRowEdit === null
        ? [{...item}, ...list]
        : list.map((x: any, i: number) => (i === indexRowEdit ? {...item} : x));

    if (source) {
      setDataTable((pre: any) => ({...pre, [key]: newList}));
    }
  };

  const handleEdit = (rowData: any, index: number, typeDialog: any) => {
    setTypeDialogAddNew(typeDialog)
    setItemSelected(rowData);
    setIndexRowEdit(index);
    setOpenDialogThemMoi(true)
  }

  const hanldeDeleteRow = (index: number, typeDelete: any) => {
    const key = typeDelete?.formVatTu;
    const list = dataTable?.[key] || [];

    const newList = list.filter((x: any, i: number) => i !== index);
    setDataTable((pre: any) => ({...pre, [key]: newList}));
  }

  const handleCloseDialog = () => {
    setItemSelected(null);
    setIndexRowEdit(null);
    setOpenDialogThemMoi(false);
    setTypeDialogAddNew(null)
  };

  return (
    <Modal
      centered
      show={show}
      // onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-phieu-khao-sat"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={{khaoSat: initialValues}}
        validationSchema={generateValidationSchema(listJsonGenerate, 'khaoSat')}
        onSubmit={handleFormSubmit}
      >
        {({values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue}) => (
          <>
            <Form onSubmit={handleSubmit}>
              <ModelHeader onHide={onHide} title={`Đề nghị chuyển giao`}/>
              <Modal.Body className="spaces p-0 bg-white h-86vh">
                <div className="spaces px-10">
                  <h4 className="title spaces mb-5 pt-10">Loại khảo sát</h4>
                  <div className="d-flex">
                    <AutocompleteObjectV2
                      options={OPTION_KHAO_SAT}
                      isSearchDefauilt={true}
                      name={"planType"}
                      value={type}
                      disabled
                      className="autocomplete-custom-renderform radius spaces min-w-200 h-29"
                    />
                  </div>
                  <div className="spaces fw-bold">
                    <hr/>
                  </div>
                </div>
                <div className="spaces px-10">
                  <GenerateFormComponent
                    isView
                    listFieldAuto={listJsonGenerate}
                    handleChange={handleChange}
                    setValues={setValues}
                    values={values}
                    touched={touched}
                    errors={errors}
                    propsRenderButton={handler}
                    setFieldValue={setFieldValue}
                    modelID={'khaoSat'}
                    customComponent={DynamicComponent}
                    warehouseId={warehouseId}
                  />
                  <hr/>
                  <GenerateFormComponent
                    // isView={isView}
                    listFieldAuto={listJsonGenerateVT}
                    handleChange={handleChange}
                    setValues={setValues}
                    values={values}
                    touched={touched}
                    errors={errors}
                    propsRenderButton={handler}
                    setFieldValue={setFieldValue}
                    modelID={'khaoSat'}
                    customComponent={DynamicComponent}
                    warehouseId={warehouseId}
                  />
                </div>
              </Modal.Body>
              <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
                {type?.formVatTu &&
                    <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                        <IconButtonSave/> Lưu
                    </Button>
                }
                {(values.khaoSat?.id || detailPhieuKeHoach?.id) && !detailPhieuKeHoach?.isView && type?.trackerCode && (
                  <WfButton
                    additionalFunc={(data: any) => {
                      setDetailPhieuKeHoach({
                        ...data,
                        ...detailPhieuKeHoach,
                        status: data?.currCode,
                        statusCode: data?.currCode,
                        statusId: data?.currId,
                      })
                      if (data?.currCode === "approved_done" && !data?.firstTime && type?.trackerCode === WF_TRACKER.SURVEY_TECHNIQUE_TRANFER) {
                        toast.success('Thành công')
                        onHide()
                      }
                    }}
                    handleClick={(data: any) => {
                      data.code === "allowed-edit" && setIsView(false);
                    }}
                    tracker={type?.trackerCode}
                    objectId={values.khaoSat?.id || detailPhieuKeHoach?.id}
                  />
                )}
              </div>
            </Form>
          </>
        )}
      </Formik>


      {openDialogThemMoi && typeDialogAddNew &&
          <DialogThemMoiDaoTao
              onOk={handleAddItem}
              show={openDialogThemMoi}
              onHide={handleCloseDialog}
              initialValues={{
                [typeDialogAddNew.formVatTu]: {
                  ...itemSelected,
                  id: indexRowEdit === null ? null : Math.random().toString(36).substring(0, 10),
                }
              }}
              type={typeDialogAddNew}
          />
      }
    </Modal>
  );
};

export default DialogDeNghiChuyenGiao;
